import styled from 'styled-components';

export const DropdownOption = styled.div`
  a {
    cursor: pointer;
    display: inline-block;
    position: relative;
    transition: 0.5s;
  }

  a:after {
    content: '»';
    position: absolute;
    opacity: 0;
    top: 16px;
    right: 20px;
    transition: 0.5s;
  }

  a:hover {
    padding-right: 24px;
  }

  a:hover:after {
    opacity: 1;
    right: 10px;
  }
`;
const greenInternational1 = '#34BF42';

export const HeaderStyles = styled.div`
  .greenRoundButton {
    background: ${greenInternational1};
    border-radius: 40px;
  }
  .ovalButton {
    border-radius: 40px;
  }
  input:focus-visible {
    outline: none;
  }
`;

export const InternationalFirstFold = styled.div`
  background: url(https://assets1.cleartax-cdn.com/cleartax/images/1675428973_arrox_bg_ani.gif);
  .greenRoundButton {
    background: ${greenInternational1};
    border-radius: 40px;
  }
  .ovalButton {
    border-radius: 40px;
  }

  .firstFoldButtons {
    gap: 24px;
  }

  input:focus-visible {
    outline: none;
  }
`;
